import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _toArray from "@babel/runtime/helpers/toArray";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import _get from 'lodash/get';
import _isArray from 'lodash/isArray';
import _isEmpty from 'lodash/isEmpty';
import _isEqual from 'lodash/isEqual';
import _isNil from 'lodash/isNil';
import _isObject from 'lodash/isObject';
import { classNames } from '../../../../utils/classname';
export function searchValueAtPath(obj, path, targetValue) {
  var pathSegments = path.split('.');
  function search(currentObj, segments) {
    if (!segments.length) {
      if (_isArray(currentObj) && currentObj.every(function (item) {
        return !_isObject(item);
      })) {
        return currentObj.includes(targetValue);
      }
      return _isEqual(currentObj, targetValue);
    }
    var _segments = _toArray(segments),
      firstSegment = _segments[0],
      restSegments = _segments.slice(1);
    if (_isArray(currentObj)) {
      return currentObj.some(function (item) {
        return search(item, segments);
      });
    }
    var nextObj = _get(currentObj, firstSegment);
    return search(nextObj, restSegments);
  }
  return search(obj, pathSegments);
}
export function filterItems(items, itemFilterKey, currentFilter, displayAllFilterValue) {
  if (_isEmpty(items) || _isNil(items)) {
    return [];
  }
  if (_isEmpty(currentFilter)) {
    return items;
  }
  if (currentFilter === displayAllFilterValue) {
    return items;
  }
  return items.filter(function (item) {
    return searchValueAtPath(item, itemFilterKey, currentFilter);
  });
}
export function createFilterValues(filters, items, itemsKey) {
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
    filtersKey = _ref.filtersKey,
    _ref$displayAllFilter = _ref.displayAllFilterValue,
    displayAllFilterValue = _ref$displayAllFilter === void 0 ? null : _ref$displayAllFilter;
  if (_isEmpty(filters) || _isNil(items)) {
    return [];
  }
  var finalFilters = filters;
  if (!_isEmpty(filtersKey)) {
    finalFilters = filters.map(function (filter) {
      return _get(filter, filtersKey);
    }).filter(Boolean);
  }

  // ensure there is at least one item for for the filter
  finalFilters = finalFilters.filter(function (filter) {
    var filteredItems = filterItems(items, itemsKey, filter, displayAllFilterValue);
    return !_isEmpty(filteredItems);
  });
  if (!_isNil(displayAllFilterValue)) {
    return [displayAllFilterValue].concat(_toConsumableArray(finalFilters));
  }
  return finalFilters;
}
export function shouldHideFilterControls(filterValues, items, itemsKey) {
  var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
    _ref2$displayAllFilte = _ref2.displayAllFilterValue,
    displayAllFilterValue = _ref2$displayAllFilte === void 0 ? null : _ref2$displayAllFilte;
  if (_isEmpty(filterValues) || _isEmpty(items)) {
    return true;
  }
  if (_isEmpty(displayAllFilterValue) && !filterValues.includes(displayAllFilterValue)) {
    return filterValues.length <= 1;
  }
  if (filterValues.length === 2 && !_isEmpty(displayAllFilterValue) && filterValues.includes(displayAllFilterValue)) {
    var nonDisplayAllFilter = filterValues.find(function (filter) {
      return filter !== displayAllFilterValue;
    });
    // return true if the non displayAllFilter filters every single item
    return items.length === filterItems(items, itemsKey, nonDisplayAllFilter, displayAllFilterValue).length;
  }

  // return false if if there are two or more valid filters
  return filterValues.length < 2;
}
export function createFilterClassName(active) {
  var baseClassNames = {
    filter: true
  };
  if (active) {
    baseClassNames = _objectSpread(_objectSpread({}, baseClassNames), {}, {
      active: true
    });
  }
  return classNames(baseClassNames);
}